import { createAction, props } from '@ngrx/store';
import { VerificationFlow } from '@ory/client';

export const RequestUpdateVerificationFlow = createAction(
  '[Auth][Verification][Request] update flow',
  props<{ code?: string; email?: string }>()
);
export const SuccessUpdateVerificationFlow = createAction(
  '[Auth][Verification][Success] update flow',
  props<{ response: VerificationFlow }>()
);
export const FailUpdateVerificationFlow = createAction(
  '[Auth][Verification][Fail] update flow',
  props<{ response: VerificationFlow }>()
);

export const RequestGetVerificationFlow = createAction(
  '[Auth][Verification][Request] get flow',
  props<{ id: string }>()
);
export const RequestCreateVerificationFlow = createAction(
  '[Auth][Verification][Request] create flow'
);

export const SuccessGetVerificationFlow = createAction(
  '[Auth][Verification][Success] get flow',
  props<{ flow: VerificationFlow }>()
);
export const FailGetVerificationFlow = createAction(
  '[Auth][Verification][Fail] get flow',
  props<{ error: any }>()
);
